<div class="gradient-button horizontal">
  @if (icon) {
    <span nz-icon style="font-size: 20px" class="material-symbols-rounded">{{ icon }}</span>
  }
  <div class="no-select">{{ text }}</div>
</div>
